/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Shares_LabelInputs */



/**
* | output |
* | --- |
* | "Shares" |
*
* @param {Team_Share_Shares_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_shares_label = /** @type {((inputs?: Team_Share_Shares_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Shares_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Partages")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Акции")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("股票")
	if (locale === "ja") return /** @type {LocalizedString} */ ("株式")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयरों")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ações")
	return /** @type {LocalizedString} */ ("Shares")
});